import { useEffect, useRef } from 'react';

import { useMediaQuery } from '../../../hooks/useMediaQuery';

export function useResize() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isMobile = useMediaQuery('(max-width: 768px)');
  useEffect(() => {
    iframeRef.current?.contentWindow?.postMessage({ type: 'window-resize', details: { isMobile } }, '*');
  }, [isMobile]);
  return { iframeRef };
}
